import React from 'react';

export interface IDarkModeContext {
  setValue: (boo: boolean) => void;
  value: boolean;
}

export const darkModeContext = React.createContext<Partial<IDarkModeContext>>({ value: false });

export const DarkModeContextWrapper = (props: { children: React.ReactNode }) => {
  const [darkModeCont, setDarkModeCont] = React.useState<boolean>(false);

  React.useEffect(() => {
    const localStorage = window.localStorage;
    var docsDarkMode = localStorage.getItem('docsDarkMode');

    if (
      !docsDarkMode &&
      window.matchMedia &&
      window.matchMedia('(prefers-color-scheme: dark)').matches
    ) {
      setDarkModeCont(true);
    } else {
      setDarkModeCont(docsDarkMode === 'true' ? true : false);
    }
  }, []);

  React.useEffect(() => {
    if (darkModeCont) {
      document.body.classList.add('DarkMode');
    } else {
      document.body.classList.remove('DarkMode');
    }
  }, [darkModeCont]);

  const updateDarkModeCont = (boo: boolean) => {
    setDarkModeCont(boo);
    localStorage.setItem('docsDarkMode', boo.toString());
  };

  return (
    <darkModeContext.Provider value={{ value: darkModeCont, setValue: updateDarkModeCont }}>
      {props.children}
    </darkModeContext.Provider>
  );
};
